/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */

import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import Image from '@components/global/Image';
import Colors from '@global/colors';
import useCommentUnread from './useCommentUnread';

// Mobile-only header entry point for comments — the mobile design puts the comment icon
// in the header (next to the "..." menu) instead of a floating action button.
const CommentHeaderButton = ({
  onPress,
  entityType,
  entityId,
  hasUnread,
  drawerVisible,
  testID,
}) => {
  const [showUnread, clearUnread] = useCommentUnread({
    entityType,
    entityId,
    hasUnread,
    drawerVisible,
  });

  const onPressButton = () => {
    clearUnread();
    onPress();
  };

  return (
    <TouchableOpacity
      testID={testID || 'comment-header-button'}
      onPress={onPressButton}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 15,
      }}>
      <View style={{ position: 'relative' }}>
        <Image
          source={require('@assets/img/icons/comment-white.svg')}
          style={{ width: 20, height: 20 }}
          width={20}
          height={20}
          svg={true}
        />
        {showUnread ? (
          <View
            style={{
              position: 'absolute',
              top: -3,
              right: -3,
              width: 9,
              height: 9,
              borderRadius: 4.5,
              backgroundColor: Colors.red3,
            }}
          />
        ) : (
          false
        )}
      </View>
    </TouchableOpacity>
  );
};

export default CommentHeaderButton;
